import { render, staticRenderFns } from "./shared-file.vue?vue&type=template&id=f0ce5664&scoped=true"
import script from "./shared-file.vue?vue&type=script&lang=js"
export * from "./shared-file.vue?vue&type=script&lang=js"
import style0 from "./shared-file.vue?vue&type=style&index=0&id=f0ce5664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ce5664",
  null
  
)

export default component.exports